<template >
  <div id="t6">
    <div class="juzhon">
      <div class="boxtitle">
        <span class="tit_left"><img src="../assets/zbfz.png" /></span>
        <div class="nav">
          <a @click="ZMchagne('A')" :class="[ZM == 'A' ? 'navactive' : '']">{{
            Masterlist.lists_A.title
          }}</a>
          <a @click="ZMchagne('B')" :class="[ZM == 'B' ? 'navactive' : '']">{{
            Masterlist.lists_B.title
          }}</a>
          <a @click="ZMchagne('C')" :class="[ZM == 'C' ? 'navactive' : '']">{{
            Masterlist.lists_C.title
          }}</a>
        </div>
        <span class="tit_right"
          ><a :href="curl + 631" target="_blank"> 更多资讯>></a></span
        >
      </div>

      <div class="Vidcontext">
        <div class="fzzb" v-if="ZM === 'A'">
          <div class="img_big">
            <a :href="aurl + lists[0].fileID" target="_blank"
              ><img :src="lists[0].pic1" alt=""
            /></a>
            <h3>
              <a :href="aurl + lists[0].fileID" target="_blank">{{
                lists[0].title
              }}</a>
            </h3>
          </div>
          <ul>
            <li v-for="(item, i) in lists" :key="i">
              <a class="img_box" :href="aurl + item.fileID" target="_blank"
                ><img :src="item.pic1" alt=""
              /></a>
              <h3>
                <a :href="aurl + item.fileID" target="_blank">{{
                  item.title
                }}</a>
              </h3>
            </li>
          </ul>
        </div>

        <div class="fzds" v-else-if="ZM === 'B'">
          <div class="videoBox">
            <video id="video" width="680" height="380" controls playsinline preload="auto"></video>
            <!-- 设置 DOM 对象 id, controls 为视频播放组件的控制功能设置-->
            <div class="xds" @click="playds()" v-if="SmallTV">
              <img src="../assets/xds.png" alt="">
              <p>电视直播</p>
            </div>
          </div>
          <div class="channel">
              <div @click="chanChange(0)" :class="[chan===0 ? 'chanactive': '']">
                <img src="../assets/fzgg.png" alt="">
                <span>抚州公共频道</span>
              </div>
              <div @click="chanChange(1)" :class="[chan===1 ? 'chanactive': '']">
                <img src="../assets/fzzh.png" alt="">
                <span>抚州综合频道</span>
              </div>
          </div>

        </div>

        <div class="fzgb" v-else-if="ZM == 'C'">
          <div class="videoBox_GB">
            <div class="xgb">
              <img src="../assets/guangbo.png" alt="">
              
              <div class="Lovebof" v-if="Love" >
                <img class="bof"  @click="palysyj()"   src="../assets/bof.png" alt="">
              </div>
              <div class="love" v-if="!Love">
                <div class="heart" >
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>

            </div>
            <video id="video" width="800" height="60" controls playsinline preload="auto"></video>
            <!-- 设置 DOM 对象 id, controls 为视频播放组件的控制功能设置-->
          </div>
          <div class="channel">
              <div @click="chanChange(2)" :class="[chan===2 ? 'chanactive': '']">
                <img src="../assets/news.png" alt="">
                <span>抚州新闻综合广播</span>
              </div>
              <div @click="chanChange(3)" :class="[chan===3 ? 'chanactive': '']">
                <img src="../assets/music.png" alt="">
                <span>抚州交通音乐广播</span>
              </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { inject, ref, onMounted,nextTick } from "vue";
import Hls from "hls.js";

export default {
  name: "T6",
  mixins: [],
  setup() {
    let ztreq = inject("ztreq");
    let aurl = ztreq.data.aurl;
    let curl = ztreq.data.curl;
    let Masterlist = ref({
      lists_A: {
        title: "抚州直播",
        id: "631",
        lists: [{ videoUrl: "", pic1: "", title: "" }],
      },
      lists_B: {
        title: "抚州电视",
        id: "2749",
        lists: [{ videoUrl: "", pic1: "", title: "" }],
      },
      lists_C: {
        title: "抚州广播",
        id: "2749",
        lists: [{ videoUrl: "", pic1: "", title: "" }],
      },
    });
    let ZM = ref("A");
    let Sel = ref(0);
    let lists = ref([{ videoUrl: "", pic1: "", title: "", fileID: "" }]);

    let chan = ref(-1);//当前选中频道
    let SmallTV=ref(true)//小电视
    let Love=ref(true) //爱心特效
    /* 抚州电视 公共 综合（统一走api.zgfznews.com代理：规避跨域、https页面嵌http流被浏览器拦截的问题） */
    let fzggVideoUrl = "https://api.zgfznews.com/fztv/gonggong.m3u8";
    let fzzhViveoUrl = "https://api.zgfznews.com/fztv/zonghe.m3u8";

    /* 新闻广播 交通广播 */
    let xwgbVideoUrl ="https://api.zgfznews.com/fztv/xinwenzongheguangbo.m3u8";
    let jtgbViveoUrl ="https://api.zgfznews.com/fztv/jiaotongyinyueguangbo.m3u8";
    
      /**
       * @param {string} id 
       * @param {stromg} url 
       * @returns {Hls}
       */
      let hls =null; //初始时没有Hls实例
      function livestream(id, url) {
        let video = document.getElementById(id);
        if(hls){
          hls.destroy(); //如果存在旧的Hls实例，先销毁
          hls =null;
        }
        hls = new Hls();
        hls.loadSource(url);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          console.log(video);
        });
        return hls;
      }
    onMounted(() => {
      axios
        .get(ztreq.data.geturl + "631&pageSize=4&articleType=2")
        .then((res) => {
          Masterlist.value["lists_" + ZM.value].lists = res.data.list;
          lists.value = Masterlist.value["lists_" + ZM.value].lists;
        });

      //初始化电视
      // {
      //   livestream("video", fzggVideoUrl);
      // }
    });

    //切换当前显示内容
    function ZMchagne(i) {
      ZM.value = i; //更新区域
      chan.value = -1; // 更新当前频道
      if(i==='B'){
        SmallTV.value=true;
        nextTick(()=>{
          livestream("video", fzggVideoUrl);
        })
      }else if(i==='C'){
        Love.value=true;
        nextTick(()=>{
          livestream("video", xwgbVideoUrl);
        })
      }
    }

    //电视切频道 
    function chanChange(i){
      if(chan.value===i) return;
      SmallTV.value=false;
      Love.value=false;
      let myVideo=document.getElementById("video");
      let videoUrls=[fzggVideoUrl,fzzhViveoUrl,xwgbVideoUrl,jtgbViveoUrl]
        nextTick(()=>{
          livestream("video", videoUrls[i]);
          myVideo.play()
        })
        chan.value = i; //更新当前频道
    }
    //点击小电视
     function playds(){
      chan.value = 0; //更新当前频道
      let myVideo=document.getElementById("video");
      myVideo.play();
      SmallTV.value=false
    }
    //点击小收音机
    function palysyj(){
      chan.value = 2; //更新当前频道
      let myVideo=document.getElementById("video");
      myVideo.play();
      Love.value=false
    }


    return {
      aurl,
      lists,
      curl,
      Masterlist,
      ZM,
      Sel,
      ZMchagne,
      fzggVideoUrl,
      fzzhViveoUrl,
      xwgbVideoUrl,
      jtgbViveoUrl,
      chanChange,
      chan,
      playds,
      SmallTV,
      Love,
      palysyj
    };
  },
};
</script>

<style scoped>
#t6 {
  min-width: 1200px;
  width: 100%;
  height: 800px;
  background-color: #f5f5f5;
  padding-top: 40px;
}
.boxtitle {
  width: 1200px;
  height: 48px;
  overflow: hidden;
  border-bottom: 4px solid #fc0000;
  margin-bottom: 60px;
}
.boxtitle img {
  width: 157px;
}
.tit_left {
  float: left;
}
.tit_right {
  float: right;
  font-size: 18px;
  color: #333;
  margin-top: 18px;
}
.tit_right a {
  font-size: 18px;
  color: #333;
}
.tit_right a:hover {
  color: #fc0000;
  text-decoration: underline;
}
.nav {
  width: 800px;
  display: inline-block;
  padding-left: 20px;
}
.nav a {
  display: inline-block;
  margin-right: 15px;
  height: 30px;
  padding: 0 20px;
  line-height: 30px;
  color: #000;
  background: #fff;
  margin-top: 9px;
  border-radius: 15px;
}
.nav a:hover {
  color: white;
  background: #fc0000;
  cursor: pointer;
}
.nav .navactive {
  color: white;
  background: #fc0000;
}

.Vidcontext {
  width: 100%;
}
.fzzb {
  display: flex;
  justify-content: space-between;
}
.fzzb .img_big {
  width: 600px;
  height: 470px;
  border: 1px solid #8b8989;
  box-shadow: 0px 0px 5px 1px #dfdcdc;
  overflow: hidden;
  border-radius: 6px;
}
.img_big h3 {
  margin-bottom: 5px;
  margin-top: 10px;
  overflow: hidden;
  line-height: 24px;
  max-height: 48px;
  font-size: 20px;
  padding: 0px 10px 0px 10px;
}
.fzzb h3 a {
  color: #565749;
}
.img_big img {
  width: 600px;
  height: 400px;
}

.fzzb ul {
  width: 580px;
  height: 470px;
}
.fzzb ul li {
  width: 268px;
  height: 220px;
  margin: 5px 0px 20px 20px;
  border: 1px solid #8b8989;
  box-shadow: 0px 0px 5px 1px #dfdcdc;
  overflow: hidden;
  border-radius: 6px;
  float: left;
}
.fzzb ul img {
  width: 268px;
  height: 140px;
}
.fzzb ul h3 {
  margin-top: 8px;
  overflow: hidden;
  line-height: 24px;
  max-height: 48px;
  font-size: 18px;
  font-weight: normal;
  padding: 0px 10px 0px 10px;
}
/*电视直播 */
.fzds{
  display: flex;
  justify-content: center;
}
.videoBox {
  width: 800px;
  height: 450px;
  background: url(../assets/dianshi.png) no-repeat top center;
  position: relative;
}
.videoBox video{
  margin: 34px 0 0 60px;
  background-color: #010101;
}
.channel{
  width: 300px;
  height: 450px;
  margin-left: 30px;
}
.channel div{
  width: 300px;
  height: 214px;
  margin-bottom: 20px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  border: solid 2px #ccc;
  border-radius: 6px;
  cursor: pointer;
}
.channel .chanactive{
  border: solid 2px #fc0000;
}
.channel div img{
  width: 300px;
  height: 170px;
  margin-bottom: 4px;
}
.xds{
  width: 180px;
  height: 200px;
  display: inline-block;
  position:absolute;
  top: 24%;
  left: 38%;
  cursor: pointer;
}
.xds img{
  width: 180px;
}
.xds p{
  color: white;
    text-align: center;
    font-size: 18px;
}

/* 广播*/
.fzgb{
  display: flex;
  justify-content: center;
}
.videoBox_GB{
  width: 800px;
  height: 450px;
}
.videoBox_GB img{
  width: 460px;
  position: relative;
  z-index: 2;
}
.xgb {
  text-align: center;
  height: 378px;
  position: relative;
}
/* 爱心特效 */
.love{
  width: 220px;
  height: 220px;
  border: solid 2px #fc0000;
  position: absolute;
  display: inline-block;
  top: 35%;
  left: 26%;
  z-index: 1;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at center, navy,black);
}
.heart{
  width: 12em;
  height: 12em;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}
.heart span{
  --c:lightblue;
  --h:50%;
  --t:25%;
  width: 0.8em;
  background-color: var(--c);
  border-radius: 0.5em;
  position: relative;
  height: var(--h);
  top: var(--t);
  animation: beating 5s infinite;
}
.heart span:nth-child(1),.heart span:nth-child(9){
  --c:orangered;
  --h:3em;
  --t:3.2em;
}

.heart span:nth-child(2),.heart span:nth-child(8){
  --c:gold;
  --h:6em;
  --t:1.8em;
}

.heart span:nth-child(3),.heart span:nth-child(7){
  --c:limegreen;
  --h:8em;
  --t:1em;
}

.heart span:nth-child(4),.heart span:nth-child(6){
  --c:dodgerblue;
  --h:9em;
  --t:1.6em;
}

.heart span:nth-child(5){
  --c:mediumpurple;
  --h:8.6em;
  --t:3em;
}
@keyframes beating{
  0%,30%{
    height: var(--h);
    top: var(--t);
    background-color: var(--c);
    filter: blur(0);
    width: 0.8em;
  }
  60%,70%{
    height: 50%;
    top: 25%;
    background-color: lightblue;
    filter: blur(4px);
    width: 0.2em;
  }
}
.videoBox_GB .xgb .bof {
    width: 162px;
    position: relative;
    z-index: 3;
    cursor: pointer;
}
.Lovebof{
    width: 224px;
    height: 180px;
    position: absolute;
    display: inline-block;
    top: 40%;
    left: 26%;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;

}
</style>